import { addMinutes, subMinutes } from "date-fns";

export const getCorrectISOString = (date: Date, minutesOffset: number) => {
  const resetDateToUtc = subMinutes(date, minutesOffset); //перевели из ЧП пользователя в UTC
  const systemOffset = -resetDateToUtc.getTimezoneOffset(); // Получили смещение системного ЧП зашитого в дату
  return addMinutes(date, systemOffset).toISOString(); //Добавили и перевели в ISO
};
